<template>
  <div class="tk-toolbar">
    <!-- Top bar -->
    <div class="top-bar">
      <v-container fluid mx-auto py-0 px-0>
        <v-layout align-center justify-center :class="{'no-static-text': !isTopBarTextAvailable}">
          <v-flex text-xs-center class="static-text">
            <top-bar-lift v-if="isTopBarTextAvailable" :lift="topBarLift" />
          </v-flex>

          <v-flex shrink v-if="$vuetify.breakpoint.mdAndUp">
            <v-item-group>
              <tk-btn small flat :href="'mailto:' + email">
                <span class="text-lowercase font-weight-regular">{{ email }}</span>
              </tk-btn>
              <tk-btn class="mx-3" small flat :href="'tel:' + phone">
                <span class="font-weight-regular">{{ phone }}</span>
              </tk-btn>
              <IconGlobe class="ml-3" style="vertical-align: middle; cursor: unset"/>
              <tk-lang-btns />
            </v-item-group>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-toolbar class="pa-0" flat :height="isMobile ? '84px' : '120px'" color="transparent" content-class="content-class">
      <v-container fluid mx-auto py-0 px-3>
        <v-layout
          items-center
          :justify-space-between="$vuetify.breakpoint.mdAndUp"
          :justify-start="$vuetify.breakpoint.smAndDown"
          row
          wrap
        >
          <!-- Menu burger -->
          <v-flex shrink align-self-center class="tk-toolbar__menu-btn" v-if="$vuetify.breakpoint.smAndDown">
            <v-toolbar-side-icon
              large
              aria-label="Menu"
              class="ml-0 mr-3"
              @click="$app.drawer = true"
            />
          </v-flex>
          <v-flex grow  class="tk-toolbar__logo" :class="{'tk-toolbar__logo--mobile': isMobile}">
            <TkLogo :small="isMobile"/>
          </v-flex>

          <!-- Categories links -->
          <!-- Text needs to change upon the language change which is not triggered without key -->
          <v-toolbar-items v-if="$vuetify.breakpoint.lgAndUp" class="ml-5" :key="$i18n.locale">
            <tk-btn
              v-for="item in categories"
              v-t="item.title"
              flat
              exact
              pa-0
              class="text-capitalize"
              :active-class="null"
              :key="item.title"
              :to="{name: 'search', query: { techs: item.techniques.join(',') }}"
              @click.native="triggerNavClickedEvent"
            />
          </v-toolbar-items>

          <v-spacer  v-if="!$vuetify.breakpoint.smAndDown"/>

          <v-flex shrink>
            <v-layout align-center justify-center fill-height>
              <!-- Desktop search input -->
              <v-flex v-if="$vuetify.breakpoint.mdAndUp">
                <v-layout align-center justify-center style="width: 430px;">
                  <v-flex>
                    <tk-search-input @mounted="$emit('searchInputMounted')" />
                  </v-flex>
                  <v-flex>
                    <tk-btn
                      color="black"
                      class="search-btn"
                      v-text="$t('SEARCH.BTN')"
                      dark
                      hidden
                      @click="toggleFilter"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- /Desktop search input -->

              <v-flex>
                <!-- Account, Mobile search button -->
                <tk-header-account />
              </v-flex>

              <!-- Cart button -->
              <v-flex>
                <tk-cart-btn />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-toolbar>
  </div>
</template>


<script>
import TkLangBtns from "@/components/core/TkLangBtns";
import TkHeaderAccount from "@/components/core/TkHeaderAccount";
import TkCartBtn from "@/components/core/TkCartBtn";
import TkSearchInput from "@/components/core/TkSearchInput";
import TkLogo from "@/components/core/TkLogo";
import TopBarLift from "@/components/core/TopBarLift";
import { companyEmail, companyPhone, categories } from "@/config";
import { ROUTE_QUERY_EVENT } from "../../AppKeys";
import IconGlobe from "@/components/base/Icon/IconGlobe.vue";

export default {
  name: "tk-toolbar",

  props: ["topBarLift"],

  components: {
    IconGlobe,
    TkLangBtns,
    TkHeaderAccount,
    TkCartBtn,
    TkSearchInput,
    TkLogo,
    TopBarLift,
  },

  data: () => ({
    phone: companyPhone,
    email: companyEmail,
    categories: categories,
  }),

  computed: {
    isTopBarTextAvailable() {
      return (
        this.topBarLift &&
        this.topBarLift.title &&
        this.topBarLift.title.en &&
        this.topBarLift.title.en.length
      );
    },
    isMobile(){
      return this.$vuetify.breakpoint.xsOnly
    }
  },

  methods: {
    toggleFilter() {
      this.$app.searchPanel = !this.$app.searchPanel;
      if (this.$route.name === "search") return;
      this.$router.push({ name: "search", query: { page: 1 } });
    },

    triggerNavClickedEvent() {
      this.$root.$emit(ROUTE_QUERY_EVENT);
    },
  },
};
</script>

<style lang="scss">
.tk-toolbar {
  &__menu-btn{
    min-width: 80px;
  }

  &__logo{

    &--mobile{
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }



  color: #000000;
  .v-toolbar__content {
    padding: 0px !important;
  }
  .xs-searchbar {
    margin-left: -16px;
  }
  .top-bar {
    background-color: var(--v-accent-base);

    .static-text p {
      margin: 0px;
      padding: 0px;
    }
    .container .layout:not(.no-static-text) {
      height: 40px;
    }
    .v-btn,
    .v-icon {
      font-size: 1.1rem;
    }
    .v-item-group {
      .v-btn {
        margin-left: 0px;
        padding: 4px;
      }
    }
  }
  .v-toolbar__items {
    .v-btn {
      padding: 12px;
      min-width: auto;
    }
  }
  .v-toolbar__side-icon {
    .v-icon {
      font-size: 2.2rem;
    }
  }
}
</style>
